import React, { useContext } from "react";
import Select from "react-select";
import { Button } from "rsuite";

import "./index.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoMdAddCircleOutline } from "react-icons/io";
import {
  getTratamentoProduto,
  getTratamentoClasse,
} from "../../../../../../Services/programation.service";
import { useQuery } from "@tanstack/react-query";
import { ConfiguracaoGlebaContext } from "../../../../../../contexts/ConfiguracaoGlebaContext";

function TratamentoSementes() {
  const { configuracaoGleba, setConfiguracaoGleba, activeCulturaIndex, setProgramacaoAlterada } = useContext(
    ConfiguracaoGlebaContext
  );

  const handleAddRow = () => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              tratamentoSementes: [
                ...(cultura?.tratamentoSementes
                  ? cultura.tratamentoSementes
                  : []),
                {
                  id: Date.now(),
                  dosagem: null,
                  similar: false,
                  produtoTratamentoId: "",
                  classeTratamentoId: "",
                },
              ],
            }
          : cultura
      ),
    }));
  };

  // Atualiza SEM mutar o estado (mutação direta corrompe o prevState de
  // outras atualizações no mesmo lote e quebra comparações do React).
  const atualizarLinha = (name, index, value) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: (prevState.culturas || []).map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              tratamentoSementes: (cultura.tratamentoSementes || []).map(
                (item, j) => (j === index ? { ...item, [name]: value } : item)
              ),
            }
          : cultura
      ),
    }));
  };

  const handleSelectChange = (name, index) => {
    return (option) => {
      atualizarLinha(name, index, option.value);
      if (name === "produtoTratamentoId") {
        // Mantém o objeto exibido no Select em sincronia com o id escolhido
        atualizarLinha("produtoTratamento", index, {
          id: option.value,
          nome: option.label,
        });
      }
      if (name === "classeTratamentoId") {
        // Mantém o objeto exibido no Select em sincronia com o id escolhido
        atualizarLinha("classeTratamento", index, {
          id: option.value,
          nome: option.label,
        });
      }
    };
  };

  const handleInputChange = (name, index, type = "text") => {
    return (e) =>
      atualizarLinha(
        name,
        index,
        type === "text" ? e.target.value : +e.target.value
      );
  };

  const TratamentoConfigurationFetch = async () => {
    const {
      res: { data: classeTratamentoData },
    } = await getTratamentoClasse();
    const {
      res: { data: produtoTratamentoData },
    } = await getTratamentoProduto();
    return {
      classesTratamento: classeTratamentoData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      produtosTratamento: produtoTratamentoData
        .filter((item) => !item.excluido)
        .map((item) => ({
          label: item.nome,
          value: item.id,
        })),
      similar: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    };
  };
  const configOptionsQueryTratamento = useQuery(
    ["configOptionsQueryTratamento"],
    TratamentoConfigurationFetch,
    {
      classesTratamento: [],
      produtosTratamento: [],
      tipoTratamento: [],
      similar: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    }
  );

  const handleRemoveRow = (idToRemove) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) =>
        i === activeCulturaIndex
          ? {
              ...cultura,
              tratamentoSementes: (cultura.tratamentoSementes || []).filter(
                (item) => item.id !== idToRemove
              ),
            }
          : cultura
      ),
    }));
  };

  const handleMoveRow = (index, direction) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: prevState.culturas.map((cultura, i) => {
        if (i !== activeCulturaIndex) return cultura;
        const lista = [...(cultura.tratamentoSementes || [])];
        const novoIndex = index + direction;
        if (novoIndex < 0 || novoIndex >= lista.length) return cultura;
        [lista[index], lista[novoIndex]] = [lista[novoIndex], lista[index]];
        return { ...cultura, tratamentoSementes: lista };
      }),
    }));
  };

  return (
    <div className="table-responsive">
      <div className="title-card">TRATAMENTO DE SEMENTES</div>
      {configuracaoGleba?.culturas?.length !== 0 ? (
        <>
        <table className="table tabela-original">
          <tbody style={{ width: "100%", marginBottom: "0px" }}>
            {(configuracaoGleba?.culturas?.[activeCulturaIndex]?.tratamentoSementes || []).map(
              (rowData, index) => (
                <tr
                  style={{
                    display: "flex",
                    width: "max-content",
                    boxShadow: "0px -4px 12px -1px rgba(0,0,0,0.45)",
                    margin: "10px",
                    // border: "solid 2px #dfdfdf",
                    borderRadius: "6px",
                    padding: "5px",
                    background: "rgba(1, 104, 32, 0.1)",
                  }}
                  key={rowData.id}
                >
                  <th
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      padding: "0 4px",
                    }}
                  >
                    <button
                      type="button"
                      className="button-move"
                      disabled={index === 0}
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity: index === 0 ? 0.25 : 1,
                      }}
                      onClick={() => handleMoveRow(index, -1)}
                      title="Subir"
                    >
                      ▲
                    </button>
                    <button
                      type="button"
                      className="button-move"
                      disabled={
                        index ===
                        (configuracaoGleba?.culturas?.[activeCulturaIndex]
                          ?.tratamentoSementes?.length || 0) - 1
                      }
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        color: "rgba(1,104,32,0.9)",
                        lineHeight: "1",
                        opacity:
                          index ===
                          (configuracaoGleba?.culturas?.[activeCulturaIndex]
                            ?.tratamentoSementes?.length || 0) - 1
                            ? 0.25
                            : 1,
                      }}
                      onClick={() => handleMoveRow(index, 1)}
                      title="Descer"
                    >
                      ▼
                    </button>
                  </th>
                  <div className="column-configs-table">
                    <th className="correct-inline">Produto</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        className="border-select"
                        value={{
                          label: rowData?.produtoTratamento?.nome,
                          value: rowData?.produtoTratamento?.id,
                        }}
                        onChange={handleSelectChange(
                          "produtoTratamentoId",
                          index
                        )}
                        // onChange={setSelectedOption}
                        options={
                          configOptionsQueryTratamento?.data?.produtosTratamento
                        }
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Classe Tratamento</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        value={{
                          label: rowData?.classeTratamento?.nome,
                          value: rowData?.classeTratamento?.id,
                        }}
                        // onChange={setSelectedOption}
                        onChange={handleSelectChange(
                          "classeTratamentoId",
                          index
                        )}
                        options={
                          configOptionsQueryTratamento?.data?.classesTratamento
                        }
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Dosagem (l ou Kg)</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="number"
                        value={rowData?.dosagem}
                        onChange={handleInputChange("dosagem", index, "number")}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Tipo</th>
                    <td>
                      <input
                        style={{
                          background: "rgba(1, 104, 32, 0.1)",
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                          textAlign: "center",
                        }}
                        disabled={true}
                        className="input-atributo"
                        type="text"
                        value={
                          configuracaoGleba.culturas[activeCulturaIndex]?.cultura
                            ?.isSementePorSaca === true
                            ? "60.000 sem."
                            : "100 Kg sem."
                        }
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Similar</th>
                    <td>
                      <Select
                        menuPosition="fixed"
                        defaultValue={{
                          label: rowData.similar ? "Sim" : "Não",
                          value: rowData.similar,
                        }}
                        onChange={handleSelectChange("similar", index)}
                        options={configOptionsQueryTratamento?.data?.similar}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">
                      Quantidade total (l ou Kg)
                    </th>
                    <td>
                      <input
                        style={{
                          background: "rgba(1, 104, 32, 0.1)",
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "15px",
                          textAlign: "center",
                        }}
                        disabled={true}
                        className="input-atributo"
                        type="text"
                        value={parseFloat(
                          configuracaoGleba.culturas[activeCulturaIndex]?.cultura
                            ?.isSementePorSaca !== false
                            ? configuracaoGleba.culturas[activeCulturaIndex]?.area
                              ? ((rowData.dosagem *
                                  configuracaoGleba.culturas[activeCulturaIndex]
                                    ?.sementePorSaca) /
                                  60000) *
                                configuracaoGleba.culturas[activeCulturaIndex]?.area *
                                ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                                  10000) /
                                  configuracaoGleba.culturas[activeCulturaIndex]?.sementePorSaca)
                              : ((rowData.dosagem *
                                  configuracaoGleba.culturas[activeCulturaIndex]
                                    ?.sementePorSaca) /
                                  60000) *
                                (configuracaoGleba.culturas[activeCulturaIndex]?.area || 0) *
                                ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                                  10000) /
                                  configuracaoGleba.culturas[activeCulturaIndex]?.sementePorSaca)
                            : configuracaoGleba.culturas[activeCulturaIndex]?.cultura?.isPms !==
                              false
                            ? configuracaoGleba.culturas[activeCulturaIndex]?.area
                              ? rowData.dosagem *
                                ((configuracaoGleba.culturas[activeCulturaIndex]?.area *
                                  ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                                    10000 *
                                    configuracaoGleba.culturas[activeCulturaIndex]?.pms) /
                                    1000)) /
                                  100)
                              : rowData.dosagem *
                                (((configuracaoGleba.culturas[activeCulturaIndex]?.area || 0) *
                                  ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                                    10000 *
                                    configuracaoGleba.culturas[activeCulturaIndex]?.pms) /
                                    1000)) /
                                  100)
                            : configuracaoGleba.culturas[activeCulturaIndex]?.area
                            ? (rowData.dosagem *
                                (configuracaoGleba.culturas[activeCulturaIndex]?.area *
                                  configuracaoGleba.culturas[activeCulturaIndex]?.kgHa)) /
                              100
                            : (rowData.dosagem *
                                ((configuracaoGleba.culturas[activeCulturaIndex]?.area || 0) *
                                  configuracaoGleba.culturas[activeCulturaIndex]?.kgHa)) /
                              100
                          //   true
                          // : configuracaoGleba.culturas[activeCulturaIndex]?.cultura?.isPms !==
                          //   true
                          // ? (rowData.dosagem *
                          //     configuracaoGleba.culturas[activeCulturaIndex]?.quantidade
                          //       .kgHa) /
                          //   100
                          // : configuracaoGleba.culturas[activeCulturaIndex]?.area
                          // ? rowData.dosagem *
                          //   ((configuracaoGleba.culturas[activeCulturaIndex]?.area *
                          //     ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                          //       10000 *
                          //       configuracaoGleba.culturas[activeCulturaIndex]?.pms) /
                          //       1000)) /
                          //     100)
                          // : rowData.dosagem *
                          //   (((configuracaoGleba.culturas[activeCulturaIndex]?.area || 0) *
                          //     ((configuracaoGleba.culturas[activeCulturaIndex]?.quantidade *
                          //       10000 *
                          //       configuracaoGleba.culturas[activeCulturaIndex]?.pms) /
                          //       1000)) /
                          //     100)
                        )
                          .toFixed(2)
                          .replace(/\./g, ",")}
                      />
                    </td>
                  </div>
                  <div className="column-configs-table">
                    <th className="correct-inline">Estádio</th>
                    <td>
                      <input
                        className="input-atributo"
                        type="text"
                        value={rowData?.estadio}
                        onChange={handleInputChange("estadio", index, "text")}
                      />
                    </td>
                  </div>
                  <th>
                    <button
                      className="button-remove"
                      variant="danger"
                      onClick={() => handleRemoveRow(rowData.id)}
                    >
                      <RiDeleteBin6Line />
                    </button>
                  </th>
                </tr>
              )
            )}
          </tbody>
        </table>
        {/* Botão FORA da <table>: <button> filho direto de <tbody> é HTML inválido */}
        <button
          className="button-add"
          variant="danger"
          onClick={handleAddRow}
        >
          <IoMdAddCircleOutline />
        </button>
        </>
      ) : (
        <>
          <div className="no-data-info">Você não possui dados cadastrados.</div>
          <Button
            className="button-add1"
            variant="danger"
            onClick={() => handleAddRow()}
          >
            <IoMdAddCircleOutline />
          </Button>
        </>
      )}
    </div>
  );
}

export default TratamentoSementes;
